class RecursiveTimeout {
  static _instance;
  stopped = false;
  timeoutInstances = [];

  static getInstance({ onTry, onCatch, onFinnaly }, timeout) {
    if (!RecursiveTimeout._instance) {
      RecursiveTimeout._instance = new RecursiveTimeout({ onTry, onCatch, onFinnaly }, timeout);
    }
    return RecursiveTimeout._instance;
  }

  constructor({ onTry, onCatch, onFinnaly }, timeout) {
    this.onTry = onTry
    this.onCatch = onCatch
    this.onFinnaly = onFinnaly
    this.timeout = timeout
  }

  async start() {
    if (this.stopped) {
      return
    }
    try {
      this.onTry && await this.onTry(this.timeout);
    } catch (error) {
      this.onCatch && this.onCatch(error);
    } finally {
      this.onFinnaly && this.onFinnaly();
      
      this.timeoutInstances.push(setTimeout(() => {
        this.start()
      }, this.timeout));
    }
  }

  stop() {
    this.stopped = true
    this.timeoutInstances.forEach(clearTimeout);
    this.timeoutInstances = [];
  }

  unlock() {
    if (this.stopped) {
      this.stopped = false
    }
  }

  changeTimeout(value) {
    this.timeout = value;
  }
}

export default RecursiveTimeout


// WEBPACK FOOTER //
// ./src/utils/recursive-timeout.js